import { IVpsPlan, IVpsPlanWithExtra } from '@/types/vps-plan.interface'
import EVpsCountry from '../enums/vps-country.enum'

const getVpsPlanExtraParams = (plan: IVpsPlan): IVpsPlanWithExtra => {
  const extra: IVpsPlanWithExtra['extra'] = {
    category: plan.groupId === 1 ? EVpsCountry.RU : EVpsCountry.EU,
    cheapestPricePerMonthByPricePerYear: Math.floor(plan.price_per_year / 12),
  }

  return {
    ...plan,
    extra,
  }
}

export default getVpsPlanExtraParams
